const sizeEquivalenceTables = {
  lecloset: {
    size_fr: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_int: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_double: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_multiple: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_us: {
      "24-25": "XS",
      "26-27": "S",
      "28-29": "M",
      "30-31": "L",
      "32-33": "XL",
      "34-35": "XXL",
      "36-37": "3XL",
      "38-39": "4XL",
      "40-41": "5XL",
    },
    size_pants: {
      "24-25": "XS",
      "26-27": "S",
      "28-29": "M",
      "30-31": "L",
      "32-33": "XL",
      "34-35": "XXL",
      "36-37": "3XL",
      "38-39": "4XL",
      "40-41": "5XL",
    },
    size_num: {
      0: "XS",
      1: "S",
      2: "M",
      3: "L",
      4: "XL",
    },
  },
  lgd: {
    size_fr: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_int: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_double: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_multiple: {
      34: "XS",
      36: "S",
      38: "M",
      40: "L",
      42: "XL",
      44: "XXL",
      46: "3XL",
      48: "4XL",
      50: "5XL",
    },
    size_us: {
      "24-25-26": "XS",
      "27-28-29": "S",
      "30-31-32": "M",
      "33-34-35": "L",
      "36-37-38": "XL",
      "39-40-41": "XXL",
    },
    size_pants: {
      "24-25-26": "XS",
      "27-28-29": "S",
      "30-31-32": "M",
      "33-34-35": "L",
      "36-37-38": "XL",
      "39-40-41": "XXL",
    },
    size_num: {
      0: "XS",
      1: "S",
      2: "M",
      3: "L",
      4: "XL",
    },
  },
};

export default sizeEquivalenceTables;
